import React, { useEffect } from 'react';
import { Form, Select } from 'antd';
import { connect } from 'react-redux';
import { Dispatch, QueryRequest, store } from '../../../utils/types';
import { updateCurrentQueryDetiails } from '../../../actions/query';

const { Option } = Select;

const correlations = ['Both', 'Positive', 'Negative'];

const Correlation = ({ values, setValues }: any) => {
  useEffect(() => {
    if (!values.correlation) {
      setValues({ ...values, correlation: correlations[0].toLowerCase() });
    }
  }, [values, setValues]);

  const onChange = (value: string) => {
    setValues({ ...values, correlation: value });
  };
  return (
    <div id="corelation" className="w-full mt-5">
      <Form.Item labelCol={{ span: 24 }} label="Correlation Type">
        <Select
          value={values.correlation}
          onChange={onChange}
          placeholder="Select Correlation"
          className="w-full rounded-select"
        >
          {correlations.map((o: string, i: number) => (
            <Option key={i} value={o.toLowerCase()}>
              {o}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  );
};

const mapStateToProps = (state: store) => ({
  values: state.query.currentQueryDetails,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setValues: (currentQueryDetails: QueryRequest) =>
    dispatch(updateCurrentQueryDetiails(currentQueryDetails)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Correlation);
